import { createQueryHook } from '~/shared/providers/api';

export interface RawUserRoleAssignment {
  id: string;
  roleId: string;
  facilityId: string;
  roleName: string;
  facilityName: string;
  createdAt: string;
}

export interface UserRoleAssignmentsQueryParams {
  userId: string;
}

export interface UserRoleAssignmentsQueryResult {
  assignments: RawUserRoleAssignment[];
}

export const useUserRoleAssignmentsQuery = createQueryHook(
  'settings.teamPermissions.userRoleAssignments',
  (params: UserRoleAssignmentsQueryParams) => ({
    coreUserRoleAssignments: {
      __args: {
        filter: {
          userId: params.userId,
          pagination: {
            limit: 1000,
            offset: 0,
          },
        },
      },
      entries: {
        id: true,
        roleId: true,
        facilityId: true,
        timestamps: {
          createdAt: true,
        },
        role: {
          id: true,
          name: true,
        },
        facility: {
          id: true,
          facilityName: true,
        },
      },
    },
  }),
  {
    select: (data): UserRoleAssignmentsQueryResult => {
      const entries = data?.coreUserRoleAssignments?.entries ?? [];

      const assignments: RawUserRoleAssignment[] = entries.map((entry) => ({
        id: entry.id,
        roleId: entry.roleId,
        facilityId: entry.facilityId,
        roleName: entry.role?.name ?? '',
        facilityName: entry.facility?.facilityName ?? '',
        createdAt: entry.timestamps?.createdAt ?? '',
      }));

      return { assignments };
    },
  },
);
